import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "order-message" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "order-title" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("h3", null, "订单信息")
], -1)
const _hoisted_3 = { class: "order-content" }
const _hoisted_4 = { class: "order-name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "订单名称", -1)
const _hoisted_6 = { class: "order-name" }
const _hoisted_7 = {
  key: 0,
  class: "order-name"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "交易时间", -1)
const _hoisted_9 = {
  key: 1,
  class: "order-name"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "服务类型", -1)
const _hoisted_11 = {
  key: 0,
  class: "client-title"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "客户信息", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "client-title"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, "匹配信息", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "client-content"
}
const _hoisted_20 = {
  key: 0,
  class: "order-name"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "昵称", -1)
const _hoisted_22 = {
  key: 1,
  class: "order-name"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, "手机", -1)
const _hoisted_24 = {
  key: 3,
  class: "client-content"
}
const _hoisted_25 = { class: "order-name" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", null, "律师", -1)
const _hoisted_27 = { class: "lawyer-list" }
const _hoisted_28 = { class: "lawyer" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { style: {"display":"flex","gap":"10px","flex-direction":"row"} }
const _hoisted_31 = ["onClick"]

import { DateFormat, FORMAT_TYPE } from "@/services/util/DateFormat";
import CopyUtils from "@/utils/CopyUtils";
import Throttle from "@/utils/Throttle";
import { reactive, ref, watch } from "vue";
import order from "@/api/order";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import UserTools from "@/services/session/UserTools";
import CheckType from "@/utils/CheckType";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex";
import { GeoEntityDesc } from "@/services/datatype/geolocation/GeoEntityDesc";

interface _clientInfo {
  //姓名
  name: string;
  //手机号
  phone: string;
  preSale: string;
  // 头像
}

interface _orderInfo {
  //标题
  title: string;
  //字面意思
  id: string;
  //创建时间
  time: string;
  type: string;
  // 头像
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Order',
  props: {
  rid: String,
  attorneyState: Boolean,
  title: String,
  type: String,
},
  setup(__props) {

const props = __props;

const dialogVisible = ref(false);
const list = ref<GeoEntityDesc[]>([]);

const isShouqian = ref<boolean>(false);
const AttorneyInfoName = ref<string>("");
const isAllocation = ref<boolean>(false);
const text = ref<string>();
const isCustomer = ref<boolean>(
  UserTools.userRoles.roles[localStorage.getItem("userRoleIndex")]
    .enterpriseInfo.enterpriseType == 29
);
const $store = useStore();
//客户信息
const clientInfo: _clientInfo = reactive({
  name: "",
  phone: "",
  preSale: "",
});
const delegateToAssistant = async (info: GeoEntityDesc) => {
  const getOrder = await order.getOrder(Number(props.rid));
  console.log (info);
  if (getOrder.customerService) {
    ElMessageBox.confirm(
      `是否邀请${info.coreGeoEntityDesc.entityInfo.entityName}`,
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        title: "确认分配",
      }
    ).then(() => {
      DefaultWebServiceFactory.getInstance()
        .getWebEnterpriseServiceRequestService()
        .delegateToCustomerServiceAssistant(
          props.rid,
          info.coreGeoEntityDesc.employerInfo?.entityId || 0,
          info.coreGeoEntityDesc.entityInfo.entityId as number
        );
      loadInfo();
      dialogVisible.value = false;
      ElMessage({
        type: "success",
        message: "分配成功!",
      });
    });
  } else {
    ElMessageBox.confirm(
      `是否将任务分配给律师${info.coreGeoEntityDesc.entityInfo.entityName}律师`,
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        title: "确认分配",
      }
    ).then(() => {
      order.delegateToAssistant(
        props.rid,
        info.coreGeoEntityDesc.entityInfo.entityId as number
      );
      loadInfo();
      dialogVisible.value = false;
      ElMessage({
        type: "success",
        message: "分配成功!",
      });
    });
  }
};
//订单信息
const orderInfo: _orderInfo = reactive({
  title: "",
  id: "",
  time: "",
  type: "",
});
const assignLawyers = () => {
  if (list.value.length == 0) {
    ElMessage({
      message: "暂无数据",
      type: "warning",
    });
    return;
  }
  dialogVisible.value = true;
};

const copyContext = Throttle(() => CopyUtils.copy(String(props.rid)), 5000);
const loadInfo = async (): Promise<void> => {
  const getOrder = await order.getOrder(Number(props.rid));
  isShouqian.value = getOrder.preSale;
  orderInfo.title = getOrder.getServiceTypeDisplayName()
  if (
    UserTools.userRoles.roles[localStorage.getItem("userRoleIndex")]
      .enterpriseInfo.enterpriseType == 29 ||
    (getOrder?.entitledToAssign && getOrder.status == 6)
  ) {
    isAllocation.value = true;
    if (
      UserTools.userRoles.roles[localStorage.getItem("userRoleIndex")]
        .enterpriseInfo.enterpriseType == 29
    ) {
      if (props.type == "客服请求") {
        list.value = await DefaultWebServiceFactory.getInstance()
          .getWebEnterpriseServiceRequestService()
          .findCustomerServiceAssistants(getOrder.rid);
      } else {
        list.value = await DefaultWebServiceFactory.getInstance()
          .getWebEnterpriseServiceRequestService()
          .findEnterpriseServiceProfessionalsToReassign(getOrder.rid);
      }
    } else {
      list.value = (
        await order.getLawyer(
          UserTools.currentRole.enterpriseInfo.entityId,
          getOrder.enterpriseServiceType
        )
      ).map((info) => {
        const geoEntityDesc = new GeoEntityDesc();
        geoEntityDesc.coreGeoEntityDesc = info;
        return geoEntityDesc;
      });
    }
    if (getOrder.assistantInfo) {
      if (
        (UserTools.userRoles.roles[localStorage.getItem("userRoleIndex")]
          .enterpriseInfo.enterpriseType == 29 &&
          localStorage.getItem("radio") == "服务监管") ||
        !getOrder.customerService
      ) {
        text.value = "重新分配";
        list.value = list.value.filter(
          (info) =>
            info.coreGeoEntityDesc.entityInfo.entityId !=
            getOrder.assistantInfo.entityId
        );
      } else {
        isAllocation.value = false
      }
    } else {
      if (getOrder.customerService) {
        text.value = "邀请服务商";
      } else {
        text.value = "分配律师";
      }
    }
  }
  if (getOrder.orderId) {
    DefaultWebServiceFactory.getInstance()
      .getWebEnterpriseServiceOrderService()
      .getEnterpriseServiceOrderByOrderId(getOrder.orderId)
      .then((t) => {
        console.log(t, 6668888);
        orderInfo.title = t.title;
        orderInfo.id = String(t.regionId);
        orderInfo.time = String(
          DateFormat.dateFormatString(
            Number(t.paymentSpec.payTime),
            FORMAT_TYPE.NORMAL3
          )
        );
      });
  } else {
    orderInfo.time = String(
      DateFormat.dateFormatString(
        Number(getOrder.createTime),
        FORMAT_TYPE.NORMAL3
      )
    );
  }
  if (getOrder.status == 13) {
    isAllocation.value = false;
  }
  AttorneyInfoName.value = getOrder.servingProfessionalInfo.entityName;
  clientInfo.name = getOrder.initiatorInfo.entityName;
  clientInfo.preSale = getOrder.preSale ? "售前" : "售后";
};
watch(props, () => loadInfo());
watch($store.state.talk.serviceExpireTime, () => loadInfo());

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", null, _toDisplayString(orderInfo.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", null, _toDisplayString(isShouqian.value ? "咨询编号" : "订单编号"), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(orderInfo.id ? orderInfo.id : props.rid) + "|", 1),
            _createElementVNode("span", {
              class: "copy",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(copyContext) && _unref(copyContext)(...args)))
            }, "复制")
          ])
        ]),
        (orderInfo.time)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("p", null, _toDisplayString(orderInfo.time), 1)
            ]))
          : _createCommentVNode("", true),
        (isCustomer.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("p", null, _toDisplayString(clientInfo.preSale), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (__props.attorneyState)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18)),
      (__props.attorneyState)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (clientInfo.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("p", null, _toDisplayString(clientInfo.name), 1)
                ]))
              : _createCommentVNode("", true),
            (clientInfo.phone)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("p", null, _toDisplayString(clientInfo.phone), 1)
                ]))
              : _createCommentVNode("", true),
            (isAllocation.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: assignLawyers
                }, _toDisplayString(text.value), 1))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("p", null, _toDisplayString(AttorneyInfoName.value), 1)
            ])
          ]))
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      width: "40%",
      style: {"border-radius":"1rem","z-index":"9999"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (info) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("img", {
                src: 
            info.coreGeoEntityDesc.entityInfo.logoImgUrl
              ? _unref(CheckType).isImg(info.coreGeoEntityDesc.entityInfo.logoImgUrl)
              : require('@/assets/images/Talk/logo.jpg')
          ,
                alt: ""
              }, null, 8, _hoisted_29),
              _createElementVNode("div", null, [
                _createElementVNode("h1", null, _toDisplayString(info.coreGeoEntityDesc.entityInfo.entityName), 1),
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.coreGeoEntityDesc.entityInfo.keywords, (key) => {
                    return (_openBlock(), _createElementBlock("p", null, _toDisplayString(key), 1))
                  }), 256))
                ])
              ]),
              _createElementVNode("div", {
                class: "assign",
                onClick: ($event: any) => (delegateToAssistant(info))
              }, "分配给TA", 8, _hoisted_31)
            ]))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})